import React, { useState } from 'react';

const References = () => {
    return (
        <>
            <div className="col-12">
                <h2 className="panel-name">References</h2>
            </div>
            <div className="col-12">
                <div className="table-responsive">
                    <table className="table table-bordered  table-striped reference-grid">
                        <thead>
                            <tr>
                                <th>Title </th>
                                <th>Description </th>
                                <th>Source Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* commented on 16 April  - As suggested by Vikram sir on call */}
                             {/* <tr>
                                <td>Blood Glucose</td>
                                <td>Standard Treatment Guidelines  - Govt of India - diabetes-mellitus</td>
                                <td>
                                    <p><a href="http://nhsrcindia.org" target="_blank">http://nhsrcindia.org</a></p>
                                    <p><a href="https://www.nhlbi.nih.gov " target="_blank">https://www.nhlbi.nih.gov </a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>Blood Cholesterols</td>
                                <td>Evaluation and Treatment of High Blood
                                    Cholesterol in Adults (Adult Treatment Panel III).
                                    NIH Publication No. 01-3305 May 2001
                                </td>
                                <td>
                                    <p><a href="https://www.nhlbi.nih.gov" target="_blank">https://www.nhlbi.nih.gov </a></p>

                                </td>
                            </tr>
                            <tr>
                                <td>Blood Tests for Kidney Functions</td>
                                <td>National Kidney Foundation - "Clinical Practice Guideline"</td>
                                <td>
                                    <p><a href="https://www.kidney.org" target="_blank">https://www.kidney.org</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>Blood Tests for Liver Functions</td>
                                <td><p>BMJ Journals - "Evaluation of abnormal liver function tests", Volume 79, Issue 932</p>
                                    <p>AASLD practice guidelines developed by a panel of experts</p></td>
                                <td>
                                    <p><a href="https://pmj.bmj.com" target="_blank">https://pmj.bmj.com</a></p>
                                    <p><a href="https://www.aasld.org" target="_blank">https://www.aasld.org</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td> Blood Tests for Thyroid Functions</td>
                                <td>American Thyroid Association</td>
                                <td>
                                    <p><a href="https://pmj.bmj.com" target="_blank">https://www.thyroid.org</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>Blood Tests for Hematology Functions</td>
                                <td>Harrison's Principles of Internal Medicine - 2 volume set Chapter 60: Disorders of Granulocytes and Monocytes, Chapter 111: Disorders of Platelets and Vessel Wall</td>
                                <td>

                                </td>
                            </tr>  */}
                            <tr>
                                <td> Nutrition</td>
                                <td>
                                    <p>National Health Portal of India</p>
                                    <p>Nutrition Committee of the American Heart Association</p>
                                    <p>American Heart Association</p>
                                    <p>Healthy diet - World Health Organization European Patients Forum (EPF)</p>
                                    <p>2015-2020 Dietary Guidelines - health.gov</p>
                                    <p>Preventive cardiology-Cardiological Society of India</p>
                                </td>
                                <td>
                                    <p><a href="https://www.nhp.gov.in" target="_blank">https://www.nhp.gov.in</a></p>
                                    <p><a href="https://www.ahajoumals.org" target="_blank">https://www.ahajoumals.org</a></p>
                                    <p><a href="https://www.heart.org" target="_blank">https://www.heart.org</a></p>
                                    <p><a href="https://www.who.int" target="_blank">https://www.who.int</a></p>
                                    <p><a href="https://european-nutrition.org" target="_blank">https://european-nutrition.org</a></p>
                                    <p><a href="https://health.gov" target="_blank">https://health.gov</a></p>
                                    <p><a href="http://www.csi.org.in" target="_blank">http://www.csi.org.in</a></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div className="col-12">
                <div className="reference-info" style={{ marginTop: 10 + 'px', fontSize: 14 + 'px', lineHeight: 140 + '%' }}>For certain parameters, international standard reference ranges, driven by international clinical guidelines, are used and ! hence, can be different from the lab reference ranges you see in your lab report.</div>
            </div>
        </>
    )
}

export default References;